export default __webpack_public_path__ + "static/zaru_collages_v6-10-b91649dad7705d7e1423c6ced215e368.png";